import OrderfastLand from '../modules/orderfastLandModule/orderfastLand';

export default OrderfastLand;
